/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstrumentation
 */

'use strict';

var ReactDebugTool = require('./ReactDebugTool');

module.exports = { debugTool: ReactDebugTool };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/react/15.2.0/react/lib/ReactInstrumentation.js
 ** module id = 31
 ** module chunks = 0
 **/